import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class Ng1ListenerService {
    private readonly _onUserUpdate = new Subject();
    readonly onUserUpdate$ = this._onUserUpdate.asObservable();

    constructor() {}

    // fired when .user() or .reload() are called in auth.js
    public onNg1UserUpdate(user: any) {
        this._onUserUpdate.next(user);
    }
}
